export default __webpack_public_path__ + "static/media/logo.6f9e39b6.jpeg";